<template>
    <popup class="navigate-to-start" v-model:visible="visible">
        <div class="html-text">
            <h2>{{ title }}</h2>
            <div v-html="content"></div>
        </div>
        <a href="#" class="button-link" @click.prevent="resolve(true)" v-html="ui.t('ok')"></a>
        <a href="#" class="button-link disabled" @click.prevent="resolve(false)" v-html="ui.t('cancel')"></a>
    </popup>
</template>

<style lang="less" scoped>

</style>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { useUI } from '../store';

    const { title, content } = defineProps<{
        title: String,
        content: String
    }>();

    const ui = useUI().ui;
    const visible = ref(false);

    let resolve: (value: boolean) => void;

    async function confirm() {
        visible.value = true;
        return new Promise<boolean>((r) => {
            resolve = (val) => {
                visible.value = false;
                r(val);
            };
        });
    }

    defineExpose({ confirm });
</script>